import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import NewComplaintModal from './Modals/NewComplaintModal/NewComplaintModal';
import UpdateProfileModal from './Modals/UpdateProfileModal/UpdateProfileModal';
import ProfileNotification from './Modals/ProfileNotification/ProfileNotification';
import ComplaintConfirmationModal from './Modals/ComplaintConfirmationModal/ComplaintConfirmationModal';
import WelcomeModal from './Modals/WelcomeModal/WelcomeModal';
import EmailModal from './Modals/EmailModal/EmailModal';
import EmailDetails from './Modals/EmailModal/EmailDetails';
import AddNewAgent from './Modals/AddNewAgent/AddNewAgent';
import AgentDetails from './Modals/AgentDetails/AgentDetails';
import AddNewCompany from './Modals/AddNewCompany/AddNewCompany';
import CloseComplaint from './Modals/CloseComplaint/CloseComplaint';
import ForgotPasswordModal from './Modals/ForgotPasswordModal/ForgotPasswordModal';
import ReOpenComplaint from './Modals/ReopenComplaint/ReOpenComplaint';
import SSORemovelModal from './Modals/SSORemovelModal';

const modalLookup = {
  NewComplaintModal,
  UpdateProfileModal,
  ProfileNotification,
  ComplaintConfirmationModal,
  WelcomeModal,
  EmailModal,
  EmailDetails,
  AddNewAgent,
  AgentDetails,
  AddNewCompany,
  CloseComplaint,
  ForgotPasswordModal,
  ReOpenComplaint,
  SSORemovelModal
};

const mapState = (state) => ({
  currentModal: state.modals,
});

const ModalManager = ({ currentModal }) => {
  let renderedModal;

  if (currentModal) {
    const { modalType, modalProps } = currentModal;
    const ModalComponent = modalLookup[modalType];
    //console.log('opened');

    renderedModal = <ModalComponent {...modalProps} />;
  }
  return <Fragment>{renderedModal}</Fragment>;
};

export default connect(mapState)(ModalManager);
